import React, { useEffect } from 'react';
import { Modal } from '@ally/metronome-ui';
import { PlaidInterstitialContent } from '../.';

interface IProps {
  isShown: boolean;
  setModalShow: (isShown: boolean) => void;
  focusEl?: HTMLElement;
  onSuccess: Function;
}

const PlaidInterstitial: React.FC<IProps> = (props) => {
  const { isShown, setModalShow, focusEl, onSuccess } = props;

  useEffect(() => {
    setModalShow(isShown);
  }, [setModalShow, isShown]);

  const modalRef: React.RefObject<HTMLElement> = React.createRef<HTMLElement>();

  return (
    <>
      <Modal
        content={
          <PlaidInterstitialContent
            setModalShow={setModalShow}
            focusEl={focusEl}
            modalRef={modalRef}
            onSuccess={onSuccess}
          />
        }
        open={isShown}
        onOpenChange={(isOpen: boolean): void => setModalShow(isOpen)}
      />
    </>
  );
};

export default PlaidInterstitial;
